<template>
  <div class="million-read-book-tag"
       :class="{ 'audio-book': bookType !== 'intensiveReading' }"
  >
    {{ bookType === 'intensiveReading' ? '' : '有声书' }}
  </div>
</template>

<script>
  export default {
    name: 'BookTag',
    props: {
      bookType: {
        type: String,
        required: true,
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .million-read-book-tag {
    box-sizing: border-box;
    width: fit-content;
    padding: 6px 12px;
    color: @color-text-base;
    font-size: @font-size-extra-extra-small;
    font-weight: @font-weight-bold;
    background: #fed100;
    border-radius: 10px 10px 10px 0;

    &.audio-book {
      color: @color-white;
      background: #5d7eff;
    }
  }

</style>
